<template>
  <div class="rofix-input-container" @click="handleFocus">
    <input
      ref="rofix_textbox"
      v-model="text"
      v-bind="$attrs"
      @input="handleInput"
      @keypress.enter="handleEnter"
    />
    <button
      v-if="$attrs.type === 'search'"
      class="search-button"
      @click="handleSearchSubmit"
    >
      <box-icon name="search"></box-icon>
    </button>
  </div>
</template>

<script>
export default {
  name: "RofixInput",
  emits: ["search", "input"],
  data() {
    return {
      text: "",
    };
  },
  methods: {
    handleFocus() {
      this.$refs.rofix_textbox.focus();
    },
    handleSearchSubmit(e) {
      this.$emit("search", { value: this.text });
    },
    handleInput(e) {
      this.$emit("input", e.target.value);
      if (!e.target.value.length) {
        this.handleEnter();
      }
    },
    handleEnter() {
      if (this.$refs.rofix_textbox.type === "search") {
        this.$emit("search", { value: this.text });
      }
    },
  },
  mounted() {
    if (
      this.$route.query.search &&
      this.$refs.rofix_textbox.type === "search"
    ) {
      this.text = this.$route.query.search || "";
      this.handleInput({
        target: { value: this.text },
      });
    }
  },
  watch: {
    "$route.query.search": {
      handler() {
        if (!this.$route.query.search?.length) {
          this.text = "";
          this.handleSearchSubmit();
        }
      },
    },
  },
};
</script>

<style>
.rofix-input-container,
.rofix-input-container input {
  width: 100%;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.rofix-input-container {
  display: flex;
  border: 1px solid var(--rofix-light-gray);
  padding: 10px;
  cursor: text;
  background-color: white;
}

.rofix-input-container input {
  border: none;
  font-size: 16px;
  outline: none;
}

.rofix-input-container .search-button {
  background: none;
  border: none;
  cursor: pointer;
  fill: var(--rofix-gray);
}
</style>
